import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication/authentication.service";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AlreadyLoggedGuard  {

  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticationService.isUserLoggedIn()) {
      if (this.authenticationService.doesUserHaveActiveSubscription()) {
        this.router.navigate(['/buildings']);
      } else {
        this.router.navigate(['/payment']);
      }
    }
    return true;
  }
}
